class ClockFace extends HTMLElement {
    static get observedAttributes() {
        return ["time"];
    }

    constructor() {
        super();
        this.attachShadow({ mode: "open" });
    }

    connectedCallback() {
        this.time = this.getAttribute("time");
        this.renderClock();
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue) {
            this.time = newValue;
            this.renderClock();
        }
    }

    isValidTimeFormat(time) {
        const timeFormat = /^([01]\d|2[0-3]):([0-5]\d)$/;
        return timeFormat.test(time);
    }

    renderClock() {
        if (!this.time) {
            console.error("[clock-face]: Missing required 'time' attribute");
            return;
        }

        if (!this.isValidTimeFormat(this.time)) {
            console.error(
                "[clock-face]: Invalid 'time' format. Expected 'HH:MM'",
            );
            return;
        }

        const [hours, minutes] = this.time.split(":").map(Number);

        const hourDegrees = (hours % 12) * 30 + minutes * 0.5;
        const minuteDegrees = minutes * 6;

        this.shadowRoot.innerHTML = `
            <style>
                .clock {
                    position: relative;
                    width: 27px;
                    height: 27px;
                    border: 3px solid black;
                    border-radius: 50%;
                }

                .hand {
                    position: absolute;
                    width: 13.5px;
                    height: 3px;
                    border-radius: 0 3px 3px 0;
                    background: black;
                    top: 50%;
                    left: 50%;
                    transform-origin: calc(100% - 1px);
                    translate: calc(-100% + 1px) -50%;
                }

                .hour {
                    width: 11.5px;
                    transform: rotate(calc(90deg + ${hourDegrees}deg));
                }

                .minute {
                    transform: rotate(calc(90deg + ${minuteDegrees}deg));
                }
            </style>
            <div class="clock">
                <div class="hand hour"></div>
                <div class="hand minute"></div>
            </div>
        `;
    }
}

customElements.define("clock-face", ClockFace);
